enum TopicDisplayMode {
	OVERVIEW = "OVERVIEW", // display disply with links that can link to full page.
	PARENT = "PARENT", // display all the details including child topics.
	REPLY = "REPLY", // display a last-level reply. no links and no children.
}

export default TopicDisplayMode;



// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/TopicDisplayMode.ts